var _path, _rect, _rect2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBed = function SvgBed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M6 1.5h8A1.5 1.5 0 0 1 15.5 3v3.5h-11V3A1.5 1.5 0 0 1 6 1.5Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 1,
    x: 6,
    y: 15,
    fill: "currentColor",
    rx: 0.5,
    transform: "rotate(90 6 15)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 1,
    x: 15,
    y: 15,
    fill: "currentColor",
    rx: 0.5,
    transform: "rotate(90 15 15)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "m15.623 6.5 1.714 6H2.663l1.714-6zM4 15.5h12a1.5 1.5 0 0 0 1.5-1.5v-1a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v1A1.5 1.5 0 0 0 4 15.5Z"
  })));
};
export default SvgBed;